module.exports = __webpack_public_path__ + "static/media/cashflow.4a3e7b9b.svg";